
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Lightbulb, Shield, Thermometer, Music, Droplets, Zap, Blinds, Smartphone, Wifi, Car } from 'lucide-react';

const AutomationCategories = () => {
  const categories = [
  {
    icon: <Lightbulb className="w-8 h-8" data-id="otk5q3eny" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Iluminación Inteligente',
    description: 'Control total de luces con escenas personalizadas, programación automática y ahorro energético de hasta 60%.',
    features: ['Control por voz', 'Programación automática', 'Ajuste de intensidad', 'Colores personalizados'],
    spaces: ['Salas', 'Recámaras', 'Cocinas', 'Jardines'],
    color: 'from-yellow-500 to-orange-500',
    brands: ['Philips Hue', 'Lutron', 'Insteon']
  },
  {
    icon: <Shield className="w-8 h-8" data-id="mcspv1eau" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Seguridad Avanzada',
    description: 'Protección integral con cámaras, sensores, alarmas y control de acceso. Monitoreo remoto 24/7.',
    features: ['Cámaras HD', 'Sensores de movimiento', 'Alarmas inteligentes', 'Control de acceso'],
    spaces: ['Entradas', 'Ventanas', 'Jardines', 'Garajes'],
    color: 'from-blue-500 to-indigo-500',
    brands: ['Ring', 'Nest', 'Fibaro']
  },
  {
    icon: <Thermometer className="w-8 h-8" data-id="7ipdpuy8w" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Climatización Eficiente',
    description: 'Termostatos inteligentes que aprenden tus preferencias y optimizan el consumo energético.',
    features: ['Control automático', 'Programación inteligente', 'Sensores de presencia', 'Ahorro energético'],
    spaces: ['Toda la casa', 'Oficinas', 'Recámaras', 'Salas'],
    color: 'from-green-500 to-teal-500',
    brands: ['Nest', 'Ecobee', 'Honeywell']
  },
  {
    icon: <Music className="w-8 h-8" data-id="eghp6egm4" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Entretenimiento y Sonido',
    description: 'Sistema Sonos integrado con HomeSeer. La banda sonora de tu vida en cada habitación.',
    features: ['Sonos integrado', 'Control por voz', 'Sincronización multizona', 'Streaming premium'],
    spaces: ['Salas', 'Recámaras', 'Cocinas', 'Jardines'],
    color: 'from-purple-500 to-pink-500',
    brands: ['Sonos', 'Bose', 'Yamaha']
  },
  {
    icon: <Blinds className="w-8 h-8" data-id="qewjqtrqt" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Persianas y Cortinas',
    description: 'Control automatizado de persianas para privacidad, comodidad y eficiencia energética.',
    features: ['Programación solar', 'Control remoto', 'Integración con clima', 'Modes de privacidad'],
    spaces: ['Ventanas', 'Balcones', 'Oficinas', 'Recámaras'],
    color: 'from-gray-500 to-blue-500',
    brands: ['Somfy', 'Lutron', 'Hunter Douglas']
  },
  {
    icon: <Droplets className="w-8 h-8" data-id="apqz69trj" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Riego Inteligente',
    description: 'Optimización del riego basada en clima, humedad del suelo y necesidades específicas de plantas.',
    features: ['Sensores de humedad', 'Programación climática', 'Ahorro de agua', 'Control remoto'],
    spaces: ['Jardines', 'Terrazas', 'Invernaderos', 'Plantas interior'],
    color: 'from-blue-500 to-green-500',
    brands: ['Rain Bird', 'Hunter', 'Orbit']
  },
  {
    icon: <Zap className="w-8 h-8" data-id="llqtc5x21" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Gestión de Energía',
    description: 'Monitoreo completo del consumo energético con optimización automática y reportes detallados.',
    features: ['Monitoreo en tiempo real', 'Análisis de consumo', 'Optimización automática', 'Reportes detallados'],
    spaces: ['Toda la casa', 'Dispositivos', 'Iluminación', 'Climatización'],
    color: 'from-yellow-500 to-red-500',
    brands: ['Sense', 'Emporia Vue', 'Aeotec']
  },
  {
    icon: <Smartphone className="w-8 h-8" data-id="n2qzmaen3" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Control por Voz',
    description: 'Integración completa con Google Home, Alexa y Siri para control natural por voz.',
    features: ['Google Home', 'Amazon Alexa', 'Apple Siri', 'Comandos personalizados'],
    spaces: ['Toda la casa', 'Cocinas', 'Salas', 'Recámaras'],
    color: 'from-indigo-500 to-purple-500',
    brands: ['Google', 'Amazon', 'Apple']
  },
  {
    icon: <Wifi className="w-8 h-8" data-id="90odvz7os" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Gestión Remota',
    description: 'Control total de tu hogar desde cualquier lugar del mundo con la app HomeSeer.',
    features: ['App móvil', 'Control remoto', 'Notificaciones', 'Monitoreo 24/7'],
    spaces: ['Toda la casa', 'Oficinas', 'Propiedades', 'Vacaciones'],
    color: 'from-teal-500 to-blue-500',
    brands: ['HomeSeer', 'SmartThings', 'Hubitat']
  },
  {
    icon: <Car className="w-8 h-8" data-id="p5pokozl6" data-path="src/components/AutomationCategories.tsx" />,
    title: 'Automatización de Garaje',
    description: 'Control inteligente de puertas de garaje con integración vehicular y seguridad avanzada.',
    features: ['Apertura automática', 'Sensores de presencia', 'Integración vehicular', 'Seguridad avanzada'],
    spaces: ['Garajes', 'Cocheras', 'Entradas', 'Patios'],
    color: 'from-gray-600 to-gray-800',
    brands: ['Chamberlain', 'Genie', 'LiftMaster']
  }];


  const specialSolutions = [
  {
    title: 'DIY Smart Home Solutions',
    description: 'Soluciones para entusiastas que prefieren instalar y configurar por sí mismos.',
    icon: '🔧'
  },
  {
    title: 'Aging In Place Solutions',
    description: 'Tecnología adaptativa para adultos mayores que desean mantenerse en su hogar.',
    icon: '❤️'
  },
  {
    title: 'Gestión de Propiedades',
    description: 'Automatización para múltiples propiedades con control centralizado.',
    icon: '🏢'
  }];


  return (
    <section id="categorias" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50" data-id="pjzb0n0xu" data-path="src/components/AutomationCategories.tsx">
      <div className="container mx-auto px-4" data-id="h7zyrnbq1" data-path="src/components/AutomationCategories.tsx">
        {/* Header */}
        <div className="text-center mb-16" data-id="ytrpij7oh" data-path="src/components/AutomationCategories.tsx">
          <Badge className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 text-sm font-medium mb-4" data-id="3crfn3moi" data-path="src/components/AutomationCategories.tsx">
            🏠 Automatización Completa
          </Badge>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" data-id="w3yi3m7g1" data-path="src/components/AutomationCategories.tsx">
            Automatiza
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" data-id="qlqktbtj9" data-path="src/components/AutomationCategories.tsx"> Todo</span> en tu Hogar
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="0ta8of5kk" data-path="src/components/AutomationCategories.tsx">
            Desde estudios y recámaras hasta cocinas, oficinas y baños. Cada espacio de tu hogar 
            puede ser inteligente con nuestras soluciones integradas.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="j1valr72x" data-path="src/components/AutomationCategories.tsx">
          {categories.map((category, index) =>
          <Card key={index} className="group hover:shadow-2xl transition-all duration-300 border-0 overflow-hidden h-full" data-id="a3ravbrhj" data-path="src/components/AutomationCategories.tsx">
              <CardContent className="p-6 h-full flex flex-col" data-id="dnzi9ygv9" data-path="src/components/AutomationCategories.tsx">
                <div className={`inline-flex p-3 rounded-lg bg-gradient-to-r ${category.color} text-white mb-4 group-hover:scale-110 transition-transform duration-300 w-fit`} data-id="lx9i1c7es" data-path="src/components/AutomationCategories.tsx">
                  {category.icon}
                </div>
                
                <div className="flex-1" data-id="i9o389x9b" data-path="src/components/AutomationCategories.tsx">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="pdo1gxq23" data-path="src/components/AutomationCategories.tsx">{category.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed" data-id="9w8e08b4h" data-path="src/components/AutomationCategories.tsx">{category.description}</p>
                  
                  <div className="space-y-4" data-id="xnr4oeagw" data-path="src/components/AutomationCategories.tsx">
                    <div data-id="uz4j3p557" data-path="src/components/AutomationCategories.tsx">
                      <h4 className="font-semibold text-gray-800 mb-2" data-id="nm3lxjy2v" data-path="src/components/AutomationCategories.tsx">Características:</h4>
                      <div className="flex flex-wrap gap-2" data-id="52khc9xka" data-path="src/components/AutomationCategories.tsx">
                        {category.features.map((feature, featureIndex) =>
                      <Badge key={featureIndex} variant="secondary" className="text-xs" data-id="kb06qvbrr" data-path="src/components/AutomationCategories.tsx">
                            {feature}
                          </Badge>
                      )}
                      </div>
                    </div>
                    
                    <div data-id="6988jilhe" data-path="src/components/AutomationCategories.tsx">
                      <h4 className="font-semibold text-gray-800 mb-2" data-id="db0vzbb1t" data-path="src/components/AutomationCategories.tsx">Espacios:</h4>
                      <div className="flex flex-wrap gap-2" data-id="5247vaig8" data-path="src/components/AutomationCategories.tsx">
                        {category.spaces.map((space, spaceIndex) =>
                      <Badge key={spaceIndex} variant="outline" className="text-xs" data-id="ftoqqlo9o" data-path="src/components/AutomationCategories.tsx">
                            {space}
                          </Badge>
                      )}
                      </div>
                    </div>
                    
                    <div data-id="plk3nawtw" data-path="src/components/AutomationCategories.tsx">
                      <h4 className="font-semibold text-gray-800 mb-2" data-id="7j6pl9pag" data-path="src/components/AutomationCategories.tsx">Marcas:</h4>
                      <div className="flex flex-wrap gap-2" data-id="8q7hmuu2n" data-path="src/components/AutomationCategories.tsx">
                        {category.brands.map((brand, brandIndex) =>
                      <Badge key={brandIndex} className="text-xs bg-blue-100 text-blue-700" data-id="hpi25a8qg" data-path="src/components/AutomationCategories.tsx">
                            {brand}
                          </Badge>
                      )}
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          )}
        </div>

        {/* Special Solutions */}
        <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-xl" data-id="sj5qc20k2" data-path="src/components/AutomationCategories.tsx">
          <div className="text-center mb-12" data-id="e9wjcoknl" data-path="src/components/AutomationCategories.tsx">
            <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="c63ze6neg" data-path="src/components/AutomationCategories.tsx">
              Soluciones Especializadas
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="yuzttdk1q" data-path="src/components/AutomationCategories.tsx">
              Adaptamos nuestras soluciones a necesidades específicas y casos de uso únicos.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="5tsar8k13" data-path="src/components/AutomationCategories.tsx">
            {specialSolutions.map((solution, index) =>
            <div key={index} className="text-center group" data-id="w7s3ximae" data-path="src/components/AutomationCategories.tsx">
                <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300" data-id="225jy1gk8" data-path="src/components/AutomationCategories.tsx">
                  <div className="text-4xl mb-4" data-id="dp8a2rilg" data-path="src/components/AutomationCategories.tsx">{solution.icon}</div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="1c4r1adgh" data-path="src/components/AutomationCategories.tsx">{solution.title}</h4>
                  <p className="text-gray-600 text-sm" data-id="ozfowfbny" data-path="src/components/AutomationCategories.tsx">{solution.description}</p>
                </div>
              </div>
            )}
          </div>

          {/* Brand Showcase */}
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-xl p-8 text-white" data-id="e06cc91wa" data-path="src/components/AutomationCategories.tsx">
            <div className="text-center mb-8" data-id="949pr7zzt" data-path="src/components/AutomationCategories.tsx">
              <h4 className="text-2xl font-bold mb-4" data-id="7k1cnv7eo" data-path="src/components/AutomationCategories.tsx">
                Trabajamos con las Mejores Marcas
              </h4>
              <p className="text-lg opacity-90" data-id="snswkbqmp" data-path="src/components/AutomationCategories.tsx">
                Insteon • Fibaro • Lutron • Sonos • Philips Hue • Nest • Ring • y muchas más
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6" data-id="1zbv937nn" data-path="src/components/AutomationCategories.tsx">
              <div className="text-center" data-id="6yl32uy75" data-path="src/components/AutomationCategories.tsx">
                <h5 className="font-semibold mb-2" data-id="n8vuf2876" data-path="src/components/AutomationCategories.tsx">🏆 Marcas Premium</h5>
                <p className="text-sm opacity-75" data-id="4a7a3ybxl" data-path="src/components/AutomationCategories.tsx">
                  Seleccionamos únicamente las marcas con mejor reputación y confiabilidad del mercado.
                </p>
              </div>
              <div className="text-center" data-id="o5on9gps5" data-path="src/components/AutomationCategories.tsx">
                <h5 className="font-semibold mb-2" data-id="v07x320gj" data-path="src/components/AutomationCategories.tsx">🔗 Integración Total</h5>
                <p className="text-sm opacity-75" data-id="8zzyusbcu" data-path="src/components/AutomationCategories.tsx">
                  Todas las marcas funcionan perfectamente integradas a través de HomeSeer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default AutomationCategories;